import 'blueimp-canvas-to-blob';
import './styles/application.sass';
import { importMap } from './dynamicImportMap';
import { dynamicRender, staticRender } from './utils';

const loadResizeObserverPolyfill = async () => {
  if (!window.ResizeObserver) {
    window.ResizeObserver = (await import('resize-observer-polyfill')).default;
  }
};
loadResizeObserverPolyfill();

// Load dynamic components
Object.entries(importMap).forEach(([componentName, { getComponent, eventListener, isHydrate }]) => {
  dynamicRender({
    componentName,
    getComponent,
    eventListener,
    isHydrate
  });
});

if (process.env.NODE_ENV !== 'production') {
  const pageTemplate = document.body.getAttribute('data-page-template');

  if (pageTemplate) {
    Object.values(importMap)
      .filter(({ pageTemplates }) => pageTemplates?.includes(pageTemplate))
      .forEach(async ({ getComponent }) => {
        await getComponent();
      });
  }
}

// Load static components, only called using react-snap
if (navigator.userAgent === 'ReactSnap' && process.env.NODE_ENV === 'production') {
  const componentName = window.location.pathname.split('/')[1];
  if (componentName) {
    const { getComponent } = importMap[componentName];

    if (getComponent) {
      staticRender({ componentName, getComponent });
    }
  }
}
